import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { CurrentPageWatcherService, UserData } from '../shared/utils/CurrentPageWatcher';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../shared/security/StorageService';
import { Subscription } from 'rxjs';
import { HomeService } from './home.service';
import { ContentPageModel, ContentPageSectionModel, ContentPageListItemModel, StringWithHyperlinkParametersModel, MessageModel } from '../model/models';
import { first } from 'rxjs/operators';
import { SectionContentModel } from '../model/sectionContentModel';
import { SectionTextModel } from '../model/sectionTextModel';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { ViewIndividualPendingTransactionsRequestModel } from '../model/viewIndividualPendingTransactionsRequestModel';
import { TransactionsService } from '../transactions/transactions.service';
import { SearchTransactionHistoryRequestModel } from '../model/searchTransactionHistoryRequestModel';
import { ChangeEmployerService } from '../broker/change-employer/change-employer.service';
import { StartFunctionResponseModel } from '../model/startFunctionResponseModel';
import * as $ from 'jquery';
import { StartFunctionService } from '../shared/utils/start-function.service';
import { BrokerTransactionApprovalService } from '../broker/view-pending-approvals/broker-transaction-approval.service';
import { IdleService } from '../shared/idle/idle.service';
import { SeverEmploymentService } from '../broker/sever-employment/sever-employment.service';
import { EntityRenewalService } from '../renewal/entity-renewal/entity-renewal.service';
import { IndividualRenewalService } from '../renewal/individual-renewal/individual-renewal.service';
import { BrokerAuditDeclarationService } from '../broker/broker-audit-declaration/broker-audit-declaration.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],

})
export class HomeComponent implements OnInit, OnDestroy {

  title: string = "Home";
  userSessionId: number;
  onLoginSubscription: Subscription = new Subscription();
  userMessages: Array<MessageModel> = [];
  //  userMessages: Array<string> = new Array<string>();
  errorMessage: boolean = false;
  homePageContent: ContentPageModel;

  alertContentPage: ContentPageSectionModel;
  whatsNewContentPage: ContentPageSectionModel;
  quickLinksContentPage: ContentPageSectionModel;
  licenseInformationContentPage: ContentPageSectionModel;
  personalInformationContentPage: ContentPageSectionModel;
  employmentInformationContentPage: ContentPageSectionModel;

  alertsContentList: Array<SectionContentModel> = [];
  whatsNewContentList: Array<SectionContentModel> = [];
  licenceInfoContentList: Array<SectionContentModel> = [];
  // sections headers
  alertHeaderContent: SectionContentModel;
  whatsNewHeaderContent: SectionContentModel;
  quickLinksHeaderContent: SectionContentModel;
  licenseInfoHeaderContent: SectionContentModel;
  personalInfoHeaderContent: SectionContentModel;
  employmentInfoHeaderContent: SectionContentModel;

  //sections footers
  alertFooterContent: SectionContentModel;
  whatsNewFooterContent: SectionContentModel;
  quickLinksFooterContent: SectionContentModel;
  licenseInfoFooterContent: SectionContentModel;
  personalInfoFooterContent: SectionContentModel;
  employmentInfoFooterContent: SectionContentModel;
  //quick links:
  //viewPendingTransactionsLink : boolean=false;

  constructor(
    private idle : IdleService,
    private spinner: SpinnerService,
    private homeService: HomeService,
    private currentPageWatcherService: CurrentPageWatcherService,
    private entityRenewalService: EntityRenewalService,
    private individualRenewalService : IndividualRenewalService,
    private storage: StorageService,
    private transactionService: TransactionsService,
    private router: Router,
    private changeEmployerService: ChangeEmployerService,
    private severEmploymentService: SeverEmploymentService,
    private startFunctionService: StartFunctionService,
    private brokerAuditDeclarationService : BrokerAuditDeclarationService) {

    this.currentPageWatcherService.sendStepMessage(null);


  }

  ngOnInit() {
    this.brokerAuditDeclarationService.clearBrokerAuditDeclarationService();
    //clear workflow informations from localstorage
    this.storage.clearStartFunctionData();
    this.changeEmployerService.clearAgreementData();
    this.changeEmployerService.clearEmploymentInfoData();
    this.changeEmployerService.clearSelectedEmployerData();

    this.severEmploymentService.clearAgreementData();
    this.severEmploymentService.clearEmploymentInfoData();
    this.severEmploymentService.clearSeverSelectedEmploymentData();

    this.entityRenewalService.clearQuestionListData();
    this.entityRenewalService.clearSelectInactiveOfficesToRenewResponseData();
    this.entityRenewalService.clearSubmitQuestionnaireAnswersResponseData()
    this.individualRenewalService.cleartIndividualCorporationStatusData();
    this.individualRenewalService.clearIndividualRenewalQuestionsData();
    this.individualRenewalService.clearSubmitIndividualQuestionnaireAnswersData();
    this.currentPageWatcherService.clearStepMessage();
    //this.currentPageWatcherService.clearUserMessage();
    this.currentPageWatcherService.notifyLeftMenuDisplay().emit(false);
    this.currentPageWatcherService.pageChanged().emit(this.title);
    this.currentPageWatcherService.lastStep = false;
    this.userSessionId = this.storage.getSessionData().userSessionId;
    console.log("user session id ", this.userSessionId);
    this.homeService.getHomePage(this.userSessionId).pipe(first())
      .subscribe((data: ContentPageModel) => {
        console.log("===============>", data);
        this.currentPageWatcherService.notifyConnectedUser().emit(true);

        this.homePageContent = data;
        if (this.homePageContent.Sections.length != 0) {
          this.homePageContent.Sections.forEach(section => {
              switch (section.Title.StringContent) {
                case "Alerts":
                    this.alertContentPage = section;
                  break;
                  case "Quick Links":
                    this.quickLinksContentPage = section;
                  break;
                  case "License Information":
                    this.licenseInformationContentPage = section;
                  break;
                  case "Personal Information":
                    this.personalInformationContentPage = section;
                  break;
                  case "Employment Information":
                    this.employmentInformationContentPage = section;
                  break;
                  case "What's New":
                      this.whatsNewContentPage = section;
                      break;
                default:
                  console.log("Unreconized Section ")
                  break;
              }
            });
      
          this.fillAlertContent();

          this.fillWhatsNewContent();
  
          this.fillQuickLinksContent();
  
          this.fillLicenseInformationContent();
  
          this.fillPersonalInformationContent();
  
          this.fillEmploymentInformationContent();
        }
       
        this.spinner.hide();
      },
        err => {
          console.log(err.message);
        }
      );
  }

  fillAlertContent() {
    if (this.homePageContent &&
      this.alertContentPage &&
      this.alertContentPage.Lists[0] &&
      this.alertContentPage.Lists[0].List) {
      let alertsSection = this.alertContentPage.Lists[0].List;
      this.mapContentSectionList(alertsSection, this.alertsContentList);

    }

    if (this.homePageContent &&
      this.alertContentPage &&
      this.alertContentPage.Header) {
      let alertSectionHeader: StringWithHyperlinkParametersModel = this.alertContentPage.Header;
      this.alertHeaderContent = this.mapStringWithHyperlinkParameters(alertSectionHeader);

    }

    if (this.homePageContent &&
      this.alertContentPage &&
      this.alertContentPage.Footer) {
      let alertSectionFooter: StringWithHyperlinkParametersModel = this.alertContentPage.Footer;
      this.alertFooterContent = this.mapStringWithHyperlinkParameters(alertSectionFooter);

    }
  }

  fillWhatsNewContent() {

    if (this.homePageContent &&
      this.whatsNewContentPage &&
      this.whatsNewContentPage.Lists[0] &&
      this.whatsNewContentPage.Lists[0].List) {
      let whatsNewSection = this.whatsNewContentPage.Lists[0].List;
      this.mapContentSectionList(whatsNewSection, this.whatsNewContentList);
    }
    if (this.homePageContent &&
      this.whatsNewContentPage &&
      this.whatsNewContentPage.Header) {
      let whatsNewSectionHeader: StringWithHyperlinkParametersModel = this.whatsNewContentPage.Header;
      this.whatsNewHeaderContent = this.mapStringWithHyperlinkParameters(whatsNewSectionHeader);

    }

    if (this.homePageContent &&
      this.whatsNewContentPage &&
      this.whatsNewContentPage.Footer) {
      let whatsNewSectionFooter: StringWithHyperlinkParametersModel = this.whatsNewContentPage.Footer;
      this.whatsNewFooterContent = this.mapStringWithHyperlinkParameters(whatsNewSectionFooter);

    }
  }

  fillQuickLinksContent() {

    if (this.homePageContent && this.quickLinksContentPage) {
      if (this.quickLinksContentPage.Header) {
        let quickSectionHeader: StringWithHyperlinkParametersModel = this.quickLinksContentPage.Header;
        this.quickLinksHeaderContent = this.mapStringWithHyperlinkParameters(quickSectionHeader);

      }

      if (this.quickLinksContentPage.Footer) {
        let quickSectionFooter: StringWithHyperlinkParametersModel = this.quickLinksContentPage.Footer;
        this.quickLinksFooterContent = this.mapStringWithHyperlinkParameters(quickSectionFooter);

      }
      /* if(this.quickLinksContentPage.Lists){
        this.quickLinksContentPage.Lists.forEach(qlink=>{
          qlink.List.forEach(links=>{
            if(links.GeneralListItem.Hyperlinks[0].LinkText=='View My Pending Transactions'){
              this.viewPendingTransactions=true;
            }
          }
          )
          })
      } */
    }
  }

  fillLicenseInformationContent() {
    //add userData on localstorage
    if (this.licenseInformationContentPage != null && this.licenseInformationContentPage.Lists[0]) {
      let userName = this.licenseInformationContentPage.Lists[0].List.filter(x => x.DefinitionListItem.Name == "Name")[0].DefinitionListItem.Value.split(",", 1)[0];
      let licenseNumber = this.licenseInformationContentPage.Lists[0].List.filter(x => x.DefinitionListItem.Name == "License Number")[0].DefinitionListItem.Value;
      let sessionData = this.storage.getSessionData();
      sessionData.userData = new UserData(userName, licenseNumber);
      this.storage.setSessionData(sessionData);
      this.currentPageWatcherService.notifyConnectedUserInfo().emit(sessionData.userData);
    }
    if (this.homePageContent && this.licenseInformationContentPage) {
      if (this.licenseInformationContentPage && this.licenseInformationContentPage.Header) {
        let licenseInformationHeader: StringWithHyperlinkParametersModel = this.licenseInformationContentPage.Header;
        this.licenseInfoHeaderContent = this.mapStringWithHyperlinkParameters(licenseInformationHeader);

      }
      if (this.licenseInformationContentPage && this.licenseInformationContentPage.Footer) {
        let licenseInformationFooter: StringWithHyperlinkParametersModel = this.licenseInformationContentPage.Footer;
        this.licenseInfoFooterContent = this.mapStringWithHyperlinkParameters(licenseInformationFooter);

      }
    }
  }

  fillEmploymentInformationContent() {
    if (this.homePageContent && this.employmentInformationContentPage) {
      if (this.employmentInformationContentPage.Header) {
        let employmentInformationHeader: StringWithHyperlinkParametersModel = this.employmentInformationContentPage.Header;
        this.employmentInfoHeaderContent = this.mapStringWithHyperlinkParameters(employmentInformationHeader);

      }
      if (this.employmentInformationContentPage.Footer) {
        let employmentInformationFooter: StringWithHyperlinkParametersModel = this.employmentInformationContentPage.Footer;
        this.employmentInfoFooterContent = this.mapStringWithHyperlinkParameters(employmentInformationFooter);
      }
    }
  }

  fillPersonalInformationContent() {
    if (this.homePageContent && this.personalInformationContentPage) {
      if (this.personalInformationContentPage.Header) {
        let personalInformationHeader: StringWithHyperlinkParametersModel = this.personalInformationContentPage.Header;
        this.personalInfoHeaderContent = this.mapStringWithHyperlinkParameters(personalInformationHeader);

      }
      if (this.personalInformationContentPage.Footer) {
        let personalInformationFooter: StringWithHyperlinkParametersModel = this.personalInformationContentPage.Footer;
        this.personalInfoFooterContent = this.mapStringWithHyperlinkParameters(personalInformationFooter);
      }
    }
  }

  mapContentSectionList(contentSectionList: Array<ContentPageListItemModel>, ContentList: Array<SectionContentModel>) {
    contentSectionList.forEach(content => {
      let text = content.GeneralListItem.StringContent;
      let contentModel: SectionContentModel = new SectionContentModel();

      if (content.GeneralListItem.Hyperlinks.length != 0) {

        for (let i = 0; i < content.GeneralListItem.Hyperlinks.length; i++) {
          let sectionTextModel = new SectionTextModel();
          let str: string = "{" + i + "}";
          sectionTextModel.text = text.split(str)[0];
          let strToReplace: string = text.split(str)[0] + str;
          text = text.replace(strToReplace, "");
          sectionTextModel.link = content.GeneralListItem.Hyperlinks[i].LinkText;
          sectionTextModel.href = content.GeneralListItem.Hyperlinks[i].Href;

          contentModel.textList.push(sectionTextModel);
        }
        if (text) {
          let sectionTextModel = new SectionTextModel();
          sectionTextModel.text = " " + text;
          contentModel.textList.push(sectionTextModel)
        }
      }
      if (content.GeneralListItem.Hyperlinks.length == 0) {
        let sectionTextModel = new SectionTextModel();
        sectionTextModel.text = content.GeneralListItem.StringContent;
        contentModel.textList.push(sectionTextModel);
      }

      ContentList.push(contentModel);
    })
  }

  mapStringWithHyperlinkParameters(header: StringWithHyperlinkParametersModel) {

    let text = header.StringContent;
    let contentModel: SectionContentModel = new SectionContentModel();
    if (header.Hyperlinks.length != 0) {

      for (let i = 0; i < header.Hyperlinks.length; i++) {
        let headerSectionText = new SectionTextModel();
        let str: string = "{" + i + "}";
        headerSectionText.text = text.split(str)[0];
        let strToReplace: string = text.split(str)[0] + str;
        text = text.replace(strToReplace, "");
        headerSectionText.link = header.Hyperlinks[i].LinkText;
        headerSectionText.href = header.Hyperlinks[i].Href;
        headerSectionText.newPage = header.Hyperlinks[i].NewPage;

        contentModel.textList.push(headerSectionText);
      }
      if (text) {
        let sectionTextModel = new SectionTextModel();
        sectionTextModel.text = text;
        contentModel.textList.push(sectionTextModel)
      }
    }
    if (header.Hyperlinks.length == 0) {
      let headerSectionText = new SectionTextModel();
      headerSectionText.text = header.StringContent;
      contentModel.textList.push(headerSectionText);
    }
    return contentModel;
  }

  startFunction(link: string, newPage: boolean) {
    //Parse Href to get function type
    this.currentPageWatcherService.sendUserMessages(null);
    let functionType = parseInt(link.substring(link.indexOf('=') + 1, link.length));

    console.log("function type!!= ", functionType);
    if (link.indexOf('startFunction.do?functionId=') > 0) {

      this.transactionService.getFunctionId(this.userSessionId, functionType)
        .subscribe((startFunctionData: StartFunctionResponseModel) => {
          let data = startFunctionData;

          
          console.log("getFunctionID response ", data);
          data.UserMessages.forEach(el => {
            this.userMessages.push(el);
          });
          this.currentPageWatcherService.sendUserMessages(this.userMessages);

          if (data.Summary == 0) {

            if (data.Workflow != null && data.Workflow.Steps != null) {
              data.Workflow.Steps.map(el => el.checked = false);
            }
            
  
            this.storage.setStartFunctionData(data);

            let functionID = data.FunctionID;
            console.log("function ID" + functionID);
            this.startFunctionService.sendStartFunctionBrokerResp(data);

            switch (functionType) {
              case 1: {
                this.individualRenewal(data);
                break;
              }
              case 2: {
                this.ChangeEmployerBroker(data);
                break;
              }
              case 4: {
                this.getIndividualPendingTransactionRequest(functionID);
                break;
              }
              case 5: {
                this.getPendingTransactionsList(data);
                break;
              }
              case 6: {
                this.getBrokerTransactionHistoryRequest(functionID);
                break;
              }
              case 7: {
                this.getIndividualTransactionHistoryRequest(functionID);
                break;
              }

              case 8: {
                this.getSeverEmployment(data);
                break;
              }

              case 9: {
                this.getBrokerAuditDeclaration(data);
                break;
              }
              
              case 10: {
                this.getTransferEmploymerCloseOffice(data);
                break;
              }
              case 12: {
                this.entityRenewal(data);
                break;
              }

              default: {
                break;
              }
            }
            this.userMessages = [];
          }
          if (data.Summary == 1 || data.Summary == 2) {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            this.userMessages = [];
          }
          this.userMessages = [];
        },
          err => {
            this.handleError(err);
            this.userMessages = [];

          });

    } else {
      if (newPage) {
        window.open(link, "_blank");
      } else {
        window.open(link, "_self");
      }

    }

  }

  
    //Individual Renewal
    individualRenewal(startFunctionResp:StartFunctionResponseModel){
      
      this.router.navigate(["/startIndividualRenewal"])
    }



  //Entity Renewal 
  entityRenewal(startFunctionResp: StartFunctionResponseModel) {
   
    this.router.navigate(["/startEntityRenewal"])
  }

  //Add change employer
  ChangeEmployerBroker(startFunctionResp: StartFunctionResponseModel) {
    // if (startFunctionResp.UserMessages != null && startFunctionResp.UserMessages.length != 0) {
    //   $("html, body").animate({ scrollTop: 0 }, "slow");
    // }
    // else {
      this.router.navigate(['/changeEmploying']);
    // }

  }

  //View My Pending Transactions
  getIndividualPendingTransactionRequest(functionId: number) {
    let individualPendingTransactionsRequestModel = new ViewIndividualPendingTransactionsRequestModel;
    individualPendingTransactionsRequestModel.FunctionID = functionId;
    console.log("individualPendingTransactionsRequestModel ", individualPendingTransactionsRequestModel)
    this.transactionService.getIndividualPendingTransactions(individualPendingTransactionsRequestModel)
      .subscribe(indivTransResp => {
        if (indivTransResp.UserMessages != undefined) {

          indivTransResp.UserMessages.forEach(el => {
              this.userMessages.push(el);
          });
        }
        this.currentPageWatcherService.sendUserMessages(this.userMessages);
        if (indivTransResp.Summary == 0) {
          this.router.navigate(['/pendingTransactions'])
            .then(() => {
              console.log("individual transaction ", indivTransResp);
              this.transactionService.notifyIndividualPendingTransactions.emit(indivTransResp);

            }
            );
          this.userMessages = [];
        }
        else {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];


        }

      },
        err => {
          this.handleError(err);
        }
      )
  }

  //View My Transaction History
  getIndividualTransactionHistoryRequest(functionId: number) {
    let transactionHistoryRequestModel = new SearchTransactionHistoryRequestModel();
    transactionHistoryRequestModel.FunctionID = functionId;
    console.log("transactionHistoryRequestModel ", transactionHistoryRequestModel);

    this.router.navigate(['/transactionIndividualHistorySearch'])
      .then(() => {

        this.transactionService.notifyTransactionIndividualHistoryModel.emit(transactionHistoryRequestModel);

      }
      );



  }

  getBrokerTransactionHistoryRequest(functionId: number) {
    let transactionHistoryRequestModel = new SearchTransactionHistoryRequestModel();
    transactionHistoryRequestModel.FunctionID = functionId;
    console.log("transactionHistoryRequestModel ", transactionHistoryRequestModel);

    this.router.navigate(['/transactionHistoryBrokerSearch'])
      .then(() => {

        this.transactionService.notifyTransactionBrokerHistoryModel.emit(transactionHistoryRequestModel);

      }
      );

  }
  //View Pending Approvals
  getPendingTransactionsList(startFunctionResp: StartFunctionResponseModel) {
    

      this.router.navigate(["/pendingApprovals"]);


  }

  getSeverEmployment(startFunctionResp: StartFunctionResponseModel) {
    
    this.router.navigate(["/severEmployer"]);
    
  }

  getTransferEmploymerCloseOffice(startFunctionResp: StartFunctionResponseModel) {
   
    this.router.navigate(["/transferEmployer"])
   
  }

  getBrokerAuditDeclaration(startFunctionResp: StartFunctionResponseModel) {
   
    this.router.navigate(["/startAuditDeclaration"])
   
  }




  handleError(err) {
    if (err.error && err.error.UserMessages != undefined) {
      err.error.UserMessages.forEach(element => {
        console.log(element);
        this.userMessages.push(element)
      });

    }
    else {
      let userMsg: MessageModel;
      userMsg.Alert = 3;
      userMsg.Description = err.message;
      this.userMessages.push(userMsg);

    }
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.currentPageWatcherService.sendUserMessages(this.userMessages);
    this.spinner.hide();

  }
  ngOnDestroy(): void {
    this.onLoginSubscription.unsubscribe();
    this.currentPageWatcherService.clearUserMessage();
  }

}




// WEBPACK FOOTER //
// ./src/app/home/home.component.ts